var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4D1F221F-2D0D-462D-93CC-8511CDC8BBED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.823529 0 0 0 0 0.823529 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-451.000000, -375.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(451.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7645163,4.57023546 L11.4070695,0.212788652 C11.1234724,-0.0707227694 10.6637616,-0.0707227694 10.3801645,0.212788652 L0.212788652,10.3801645 C0.0765825817,10.5163295 0,10.7010216 0,10.893617 L0,15.2510638 C0,15.6521557 0.325149231,15.977305 0.726241135,15.977305 L5.08368794,15.977305 C5.27628333,15.977305 5.46097549,15.9007224 5.59714043,15.7645163 L15.7645163,5.59714043 C16.0480277,5.31354337 16.0480277,4.85383252 15.7645163,4.57023546 Z M4.78302411,14.5248227 L1.45248227,14.5248227 L1.45248227,11.1942809 L8.71489362,3.9318695 L12.0454355,7.26241135 L4.78302411,14.5248227 Z M13.0723404,6.23550638 L9.74179858,2.90496454 L10.893617,1.7531461 L14.2241589,5.08368794 L13.0723404,6.23550638 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.3980742608d7e74ee2299572a1cde7e6.svg";